import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 空室／空床更新通知 API 操作クラス
 */
export default class NotificationRoomSchedules {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * POST notifyByLine
   */
  public async notifyByLine(userStore: LoginUser): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.NotifyRoomSchedulesByLine, formatParams);
    const response = await this.commonService.executePost<any>(userStore, requestUrl, {}, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * POST notifyByMail
   */
  public async notifyByMail(userStore: LoginUser): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.NotifyRoomSchedulesByMail, formatParams);
    const response = await this.commonService.executePost<any>(userStore, requestUrl, {}, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}
